import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { TabModule } from '../tab/tab.module';
import { TabPanelComponent } from './tab-panel.component';

@NgModule({
	declarations: [TabPanelComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		TabModule,
		FreudTypographyModule,
	],
	exports: [TabPanelComponent],
})
export class TabPanelModule {}
